import _ from "lodash";

import { CLEAR_KEYWORD } from "api/constants";
import { convertMatrixValue } from "containers/lists/subcategories/items/utils/convertItem";
import { IListSchema } from "model/entities/List";
import { CUSTOM_FIELD_TYPE, IQuestion } from "model/entities/Workflow";

interface IPrepareCustomFieldDataForBackend {
  question?: IListSchema | IQuestion;
  answer: any;
  simpleMatrixFormat?: boolean;
  skipMatrix?: boolean;
  listMultipleChoice?: boolean;
}

const prepareCustomFieldDataForBackend = ({
  question,
  answer,
  simpleMatrixFormat,
  skipMatrix,
  listMultipleChoice,
}: IPrepareCustomFieldDataForBackend) => {
  // use null to decide whether or not to perform update at the end
  // (an undefined answer will be written in the report, but null will be skipped)
  let convertedAnswer = null;

  switch (question?.type) {
    case CUSTOM_FIELD_TYPE.SINGLE_CHOICE:
    case CUSTOM_FIELD_TYPE.SINGLE_CHOICE_ON_LIST: {
      // expected input format: {key: "A", label: "a"}
      convertedAnswer = answer?.key ?? answer;
      break;
    }
    case CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE: {
      // expected  input format for activity: [{key: "A", label: "a"}, ... ]
      // expected input format for list: {key: true, key:true}
      if (listMultipleChoice) {
        convertedAnswer = answer.reduce((acc: any, obj: any) => {
          const key = obj.key || obj;
          if (key !== CLEAR_KEYWORD) {
            acc[key] = true;
          }
          return acc;
        }, {});
      } else {
        convertedAnswer = Array.isArray(answer)
          ? answer.map((k: any) => k.key ?? k)
          : answer;
      }

      break;
    }

    case CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE_ON_LIST: {
      // expected input format: [{key: "A", label: "a"}, ... ]
      convertedAnswer = Array.isArray(answer)
        ? answer.map((k: any) => k.key ?? k)
        : answer;

      break;
    }
    case CUSTOM_FIELD_TYPE.MATRIX_ON_LIST: {
      if (skipMatrix) return answer;

      // simpleMatrixFormat should be true for matrix format for ME resolution
      convertedAnswer = convertMatrixValue({
        customField: question,
        value: answer,
        subElementsCallback: ({ customField, value }) =>
          prepareCustomFieldDataForBackend({
            answer: value,
            question: customField,
            simpleMatrixFormat,
          }),
        simpleMatrixFormat,
      });
      break;
    }
    case CUSTOM_FIELD_TYPE.BOOLEAN: {
      convertedAnswer = _.toLower(answer) === "true";
      break;
    }
    default: {
      convertedAnswer = answer;
      break;
    }
  }
  return convertedAnswer;
};

export default prepareCustomFieldDataForBackend;
